import { render } from "./CreateWishlistModal.vue?vue&type=template&id=7f604284&scoped=true"
import script from "./CreateWishlistModal.vue?vue&type=script&lang=js"
export * from "./CreateWishlistModal.vue?vue&type=script&lang=js"

import "./CreateWishlistModal.vue?vue&type=style&index=0&id=7f604284&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f604284"]])

export default __exports__